import React, { memo, useCallback, useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Grid,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { CustomInputField } from "../CommonComponents/CustomCompontes";
import { companyWiseEmp } from "../../actions/Companywiseclient";

const customTableHeaders = [
  {
    label: "S. No",
    key: "sno",
  },
  {
    label: "Name",
    key: "empName",
  },
  {
    label: "Login Permission",
    key: "hasLoginPermission",
  },
  {
    label: "",
    key: "hasLoginPermissionSwitch",
  },
];
const getNestedValue = (obj, key) => {
  if (!key) return undefined;

  return key.split(".").reduce((acc, part) => {
    if (acc && acc[part] !== undefined) {
      return acc[part];
    }

    return undefined;
  }, obj);
};

const CustomUserListRow = memo(
  ({ rowData, rowIndex, handleChangeUserLoginPermission = () => {} }) => {
    const handleChangeUserLoginPermissionOnChecked = useCallback(
      (selectedUserId) => {
        handleChangeUserLoginPermission(selectedUserId);
      },
      [handleChangeUserLoginPermission]
    );
    return (
      <TableRow>
        {customTableHeaders?.map((header, index) => {
          return (
            <TableCell
              key={`user-list-body-cell-${index}`}
              sx={{ paddingY: "10px" }}
            >
              {header?.key === "sno" ? (
                <span>{rowIndex + 1}</span>
              ) : header?.key === "hasLoginPermissionSwitch" ? (
                <Switch
                  checked={rowData["hasLoginPermission"] || false}
                  onChange={() =>
                    handleChangeUserLoginPermissionOnChecked(rowData?.id)
                  }
                  color="secondary"
                />
              ) : header?.key === "empName" ? (
                <span>
                  {getNestedValue(rowData, "name") || "-"} (
                  {getNestedValue(rowData, "empcode") || "-"})
                </span>
              ) : header?.key === "hasLoginPermission" ? (
                <span
                  style={{
                    color:
                      rowData["hasLoginPermission"] === true
                        ? "green"
                        : rowData["hasLoginPermission"] === false
                        ? "red"
                        : "black",
                  }}
                >
                  {rowData["hasLoginPermission"] === true
                    ? "Allowed"
                    : "Not Allowed"}
                </span>
              ) : (
                <span>{getNestedValue(rowData, header.key) || "-"}</span>
              )}
            </TableCell>
          );
        })}
      </TableRow>
    );
  }
);

const UserLoginConfiguration = ({
  companyId,
  userLoginPermissionCacheuster,
  siteId,
}) => {
  const [hrmsUserListArr, setHrmsUserListArr] = useState([]);
  // console.log("somya hrmsUserListArr  : ", hrmsUserListArr);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loginFilter, setLoginFilter] = useState(null);
  // console.log("loginFilter ", loginFilter);
  const [
    selectAllUserLoginPermissionConfiguration,
    setSelectAllUserLoginPermissionConfiguration,
  ] = useState(false);

  const FetchhrmsUserListByCompanyId = useCallback(() => {
    // let companyId = JSON.parse(localStorage.getItem("data")).hrmsCompanyId;
    const hrmsToken = JSON.parse(localStorage.getItem("data")).hrmsToken;
    companyWiseEmp
      .getHrmsUserListByCompanyId({
        companyId: companyId?.id,
        hrmsToken,
        siteId: siteId?.id || null,
      })
      .then((response) => {
        // console.log("FetchhrmsUserListByCompanyId data: ", response);
        if (response !== null) {
          if (Boolean(response?.data?.length)) {
            setHrmsUserListArr(response?.data || []);
            setFilteredUsers(response?.data || []);
          }

          if (response.responseCode === 404) {
            alert("No record found Status List!!");
            setHrmsUserListArr([]);
            setFilteredUsers([]);
          }
        }
      });
  }, [companyId?.id]);

  const handleChangeUserLoginPermission = useCallback((selectedUserId) => {
    setFilteredUsers((prev) =>
      prev.map((user) =>
        user.id === selectedUserId
          ? { ...user, hasLoginPermission: !user.hasLoginPermission }
          : user
      )
    );
    setHrmsUserListArr((prev) =>
      prev.map((user) =>
        user.id === selectedUserId
          ? { ...user, hasLoginPermission: !user.hasLoginPermission }
          : user
      )
    );
  }, []);

  const handleUpdateUserLoginPermission = useCallback(async () => {
    const updatedUsers = hrmsUserListArr
      ?.filter((item) => item?.hasLoginPermission)
      ?.map((item) => item?.id);

    // console.log("handleUpdateUserLoginPermission : ", updatedUsers);

    // let companyId = JSON.parse(localStorage.getItem("data")).hrmsCompanyId;

    const payload = {
      companyId: companyId?.id,
      hrmsUserIds: updatedUsers,
      siteId: siteId?.id || null,
    };

    const res = await companyWiseEmp?.saveUserLoginConfigurationByComapnyId(
      payload
    );

    // console.log("update user list res: ", res);
    if (res?.data && res?.data?.responseCode === 200) {
      alert(
        res?.data?.responseDescription ||
          "User login permissions updated successfully"
      );
      setSearchTerm("");
      setLoginFilter(null);
      FetchhrmsUserListByCompanyId();
    } else {
      alert(
        res?.data?.message ||
          res?.message ||
          "Failed to save user login permissions"
      );
    }
  }, [hrmsUserListArr, FetchhrmsUserListByCompanyId, companyId?.id]);

  const handleChangeSelectAllUserLoginPermissionConfigSwitch =
    useCallback(() => {
      if (selectAllUserLoginPermissionConfiguration) {
        setHrmsUserListArr((prev) =>
          prev?.map((user) => ({ ...user, hasLoginPermission: false }))
        );
      } else if (!selectAllUserLoginPermissionConfiguration) {
        setHrmsUserListArr((prev) =>
          prev?.map((user) => ({ ...user, hasLoginPermission: true }))
        );
      }
    }, [selectAllUserLoginPermissionConfiguration]);

  useEffect(() => {
    if (companyId) {
      setSearchTerm("");
      setLoginFilter(null);
      FetchhrmsUserListByCompanyId();
    } else if (!companyId) {
      setSearchTerm("");
      setLoginFilter(null);
      setHrmsUserListArr([]);
    }
  }, [
    companyId,
    FetchhrmsUserListByCompanyId,
    userLoginPermissionCacheuster,
    siteId,
  ]);

  useEffect(() => {
    // console.log("cell renders");
    const timer = setTimeout(() => {
      const trimmedTerm = searchTerm.trim().toLowerCase();

      let filtered = hrmsUserListArr;

      if (trimmedTerm) {
        filtered = filtered.filter(
          (user) =>
            user.name.toLowerCase().includes(trimmedTerm) ||
            user.empcode.toLowerCase().includes(trimmedTerm)
        );
      }

      if (loginFilter !== null) {
        filtered = filtered.filter(
          (user) => user.hasLoginPermission === loginFilter
        );
      }

      setFilteredUsers(filtered);
    }, 200);

    return () => clearTimeout(timer);
  }, [searchTerm, loginFilter, hrmsUserListArr]);

  useEffect(() => {
    const allUsersHavePermission = hrmsUserListArr.every(
      (user) => user.hasLoginPermission
    );
    setSelectAllUserLoginPermissionConfiguration(allUsersHavePermission);
  }, [hrmsUserListArr]);

  return (
    <div>
      <Accordion className="main_accoardian" defaultExpanded={true}>
        <AccordionSummary
          className="accordianHeader"
          expandIcon={
            <AddCircleIcon fontSize="large" style={{ color: "white" }} />
          }
          aria-controls="panel1a-content"
          style={{
            background: "rgb(10 166 141)",
            borderRadius: "10px 10px 0px 0px",
            overflow: "hidden",
          }}
        >
          <Grid>
            <Grid>
              <h3
                style={{
                  color: "#fff",
                  marginLeft: "10px",
                  padding: "10px 2px",
                }}
              >
                User Login Configuration
              </h3>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ mt: 1 }}>
            <Grid container direction="row" spacing={3} alignItems="center">
              <Grid item spacing={3} xs={3}>
                <CustomInputField
                  sx={{ margin: "0px !important" }}
                  value={searchTerm}
                  label="Search "
                  variant="outlined"
                  size="small"
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Grid>
              <Grid item spacing={3} xs={9}>
                <div className="field_box">
                  <Autocomplete
                    size="small"
                    className="select_box"
                    value={
                      loginFilter !== null
                        ? [
                            { name: "Active", value: true },
                            { name: "Inactive", value: false },
                          ].find((opt) => opt.value === loginFilter) || null
                        : null
                    }
                    options={[
                      {
                        name: "Active",
                        value: true,
                      },
                      {
                        name: "Inactive",
                        value: false,
                      },
                    ]}
                    getOptionLabel={(option) => `${option.name}`}
                    disablePortal={true}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    fullWidth
                    onChange={(event, newValue) => {
                      setLoginFilter(newValue ? newValue.value : null);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        margin="dense"
                        placeholder="Select Permission Status"
                      />
                    )}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <TableContainer
                  component={Paper}
                  sx={{ maxHeight: "450px", overflow: "auto" }}
                >
                  <Table size="small" aria-label="a dense table" stickyHeader>
                    <TableHead>
                      <TableRow>
                        {customTableHeaders?.map((item, index) => {
                          if (item?.key === "hasLoginPermissionSwitch") {
                            return (
                              <TableCell
                                key={`user-list-head-${index}`}
                                className="tabalecellStyle"
                                sx={{ bgcolor: "#32577e", color: "#fff" }}
                              >
                                <Switch
                                  checked={
                                    selectAllUserLoginPermissionConfiguration
                                  }
                                  onChange={() =>
                                    handleChangeSelectAllUserLoginPermissionConfigSwitch()
                                  }
                                  color="secondary"
                                />
                              </TableCell>
                            );
                          }
                          return (
                            <TableCell
                              key={`user-list-head-${index}`}
                              className="tabalecellStyle"
                              sx={{ bgcolor: "#32577e", color: "#fff" }}
                            >
                              {item?.label}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {filteredUsers?.map((item, index) => {
                        return (
                          <CustomUserListRow
                            key={`user-list-head-${index}`}
                            rowData={item}
                            rowIndex={index}
                            handleChangeUserLoginPermission={
                              handleChangeUserLoginPermission
                            }
                          />
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  placeItems: "center",
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingTop: "10px",
                }}
              >
                <div className="field_box">
                  <div
                    className="field_box_btn1"
                    onClick={() => handleUpdateUserLoginPermission()}
                    style={{
                      cursor: "pointer",
                      width: "60px",
                    }}
                  >
                    Save
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default UserLoginConfiguration;
